export default "__VITE_ASSET__CRncrD2A__"